import { uiInitState, uiReducers } from "./reducer";
import { createSlice } from "@reduxjs/toolkit";

export const SLICE_NAME = "ui";

export const uiState = createSlice({
  name: SLICE_NAME,
  initialState: uiInitState,
  reducers: uiReducers,
});

export const ACTIONS = uiState.actions;
export default uiState.reducer;
